import React, {  useRef, useState, useContext } from 'react';
import { DFPAPIEndpoint,APIEndpoint, DFPAPIEndpointGalley } from "../../../utils/axios";
import searchIcon from '../../../assets/icons/search.svg';
import '../../../assets/styles/styles.scss';
import editIcon from "../../../assets/edit.svg";
import { DataGrid, EditModal,UploadModal ,DeleteConf,NGODatePicker} from "../../../common";
import { ConfigureGalley } from './configureGalley';
import { onDownloadXlsFile,formatDateByTimezone} from '../../../utils/commonFunctions';
import usePermissions from '../../../utils/userPermissions';
import {ThemeContext} from "../../../contexts/themeContext";
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { CreateAircraft } from './createAircraft';

export const AircraftType = (props) => {
  const { t,ready } = useTranslation();
  const [searchKey, setSearchKey] = useState('');
  const[state,setState]=useState({deleteProg:false});
  const [airCraft,setAirCraft]=useState({});
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [classCapacityConfig,setClassCapacityConfig]=useState([]);
    const [dateChange, setDateChange] = useState(new Date(moment()));
    const [seatPriceList, setSeatPriceList] = useState({date:new Date(moment()),sector:'dom'});
      const [priceSector, setPriceSector] = useState('');
    const [data, setData] = useState([]);
    const PriceDate = moment(formatDateByTimezone(new Date(dateChange),false)).format('YYYY-MM-DD')
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const tableRef = useRef();
  const {themedColor} = useContext(ThemeContext);

  const { hasPermission: editAircraftType } = usePermissions('edit', "configuration.fsc.aircraft-type");
  const { hasPermission: createAircraftType  } = usePermissions('create', "configuration.fsc.aircraft-type");
  const { hasPermission: viewDetailsAircraftType  } = usePermissions('viewDetails', "configuration.fsc.aircraft-type");
  const { hasPermission: uploadAircraftType  } = usePermissions('upload', "configuration.fsc.aircraft-type");

React.useEffect(() => {
  if(state  && state?.selected && state.resetDataSource){
    fetchAirtcraftsType();
    setAirCraft(state.selected);
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [state]);


React.useEffect(() => {
  if(state  && state?.selected && state.selected.data){
    handleViewSeatprice(state.selected.data);
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [seatPriceList]);

React.useEffect(() => {
fetchConfigClassCodes();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
  const preCompile = {
    save:t('buttons.save'),
    uploadLayout:t('pages.pagesContent.aircrafts.uploadLayout')
  }
  function layoutComponent(props) {

    return (
      props.data?
      <div>
     { viewDetailsAircraftType ? <button className="grid-download-btnStyle1" onClick={(e) => setSector(props.data, 'viewLayout')}>View</button>:<></>}
       { uploadAircraftType ?<button  style={{marginLeft:'0.9rem'}} className="grid-download-btnStyle1" onClick={(e) => setSector(props.data, 'uploadLayout')}>Upload</button>:<></>}
      </div> : <div></div>
    );
  }

function configureGalley(props){
    return (
        props.data?
        <div>
          <button className="grid-download-btnStyle1" onClick={(e) => setSector(props.data, 'configureGalley')}>Configure</button>
        </div> : <div></div>
      );
}


function actionsAircrafts(props){
  return (
    props.data?
    <>
    <div className='flexRow margTop8'>
      {editAircraftType? <div className='icon-aircraft-container'>
      <img className='aircraft-actions' alt='edit' onClick={(e) => setSector(props.data, 'editAircraft')} src={editIcon}/>
      <span className="tooltip-action">Edit</span>
      </div>:<></>}
    </div>

    </> : <></>
  );
}

    async function  handleViewSeatprice(props) {
      setData([]);
        const body={
         date:formatDateByTimezone(new Date(seatPriceList.date),false),
          sectorType:seatPriceList.sector
        }

      try {
        const res =  await DFPAPIEndpoint.post(`aircraftTypes/${props.id}/seatPricelists/byDate`,body)

        setSector(props.data,"SeatPriceList")
        setState((_prev) => {
          return { ..._prev, selected: {..._prev.selected,action: 'SeatPriceList',data:props  },edit:false,resetDataSource: false  }
      });
        setData(res?.items||[]);
      } catch (error) {

      }
    };


const fetchConfigClassCodes=async()=>{
  try {
    const resp = await DFPAPIEndpointGalley.get('galley/mealMenuPlan/configs');
    if(resp.data&&resp.data.classCodes?.list?.length>0){
    setClassCapacityConfig(resp.data.classCodes?.list?.map(cl=>({
      classCode: cl.id,
      seatCapacity: 0,
      className: cl.label
  })))
    }
    }
    catch (error) {

    }
}
function PriceListComponent(props) {

  return (
    props.data?
    <div>
      <button className="grid-download-btnStyle1" onClick={(e) => handleViewSeatprice(props.data)}>View</button>
      <button  style={{marginLeft:'2rem'}} className="grid-download-btnStyle1" onClick={(e) => setSector(props.data, 'PricelistUploadLayout')}>Upload</button>
    </div> : <div></div>
  );
}

  const Columns = [
    { field: 'key',headerName: 'Aircraft Model', valueGetter: function(params) {
      if(params&&params.data){
        return params.data.key.slice(0,params.data.key.indexOf("-"))
      };
    },cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },
    suppressSizeToFit:true,flex:1, width:130,minwidth:100,resizable:true,tooltipField: 'key',pinned:'left',autoResize:true },
    { field: 'variant',headerName: 'Variant',resizable: true, suppressSizeToFit:true,flex:1, minWidth: 180},
    { field: 'haulType',headerName: 'Type',resizable: true,suppressSizeToFit:true,flex:1, minWidth: 130 },
    { field: 'bodyType',headerName: 'Body',resizable: true,suppressSizeToFit:true,flex:1, minWidth: 130 },
    { field: 'classCapacity',headerName: 'First Class',valueFormatter: params=>{

      if(params&&classCapacityConfig.length>0){
        const data=params?.value?.find(v=>v.classCode===classCapacityConfig[0].classCode)
        if(data){
          return data.seatCapacity
        }
        else{
          return ''
        }
       }
   }, minWidth: 130 , suppressSizeToFit:true,flex:1},
    { field: 'classCapacity',headerName: 'Business Class', flex:1, valueFormatter: params=>{
      if(params&&classCapacityConfig.length>0){
        const data=params?.value?.find(v=>v.classCode===classCapacityConfig[1].classCode)
        if(data){
          return data.seatCapacity
        }
        else{
          return ''
        }
       }
   }, minWidth: 130, suppressSizeToFit:true },
    { field: 'classCapacity',headerName: 'Premium Economy', flex:1, valueFormatter: params=>{
      if(params&&classCapacityConfig.length>0){
        const data=params?.value?.find(v=>v.classCode===classCapacityConfig[2].classCode)
        if(data){
          return data.seatCapacity
        }
        else{
          return ''
        }
       }
   }, minWidth: 130 ,suppressSizeToFit:true},
    { field: 'classCapacity',headerName: 'Economy', flex:1, valueFormatter: params=>{
      if(params&&classCapacityConfig.length>0){
        const data=params?.value?.find(v=>v.classCode===classCapacityConfig[3].classCode)
        if(data){
          return data.seatCapacity
        }
        else{
          return ''
        }
       }
   }, minWidth: 130, suppressSizeToFit:true },
   {
    headerName:'Actions',
    pinned:'right',
     autoResize:true,
      width:100,
      resizable: false,
      suppressSizeToFit:true,
      headerClass: 'actions-header',
      cellRenderer: actionsAircrafts,
      valueGetter: function(params) {
        return params.sectors;
      }
    }
,
       {headerName:'Seat Layout',
       pinned:'right',
       autoResize:true,
        width:200,
        resizable:false,
        suppressSizeToFit:true,
        cellRenderer: layoutComponent,
        valueGetter: function(params) {
          return params.sectors;
        }
      },

    {
      headerName:'Galleys',
      pinned:'right',
       autoResize:true,
        width:140,
        resizable: false,
        suppressSizeToFit:true,
        cellRenderer: configureGalley,
        valueGetter: function(params) {
          return params.sectors;
        }
      },
      
    {headerName:'Seat Pricelist',
      pinned:'right',
      minWidth:230,
       width:250,
       resizable:false,
       suppressSizeToFit:true,
       cellRenderer: PriceListComponent,
       valueGetter: function(params) {
         return params.sectors;
       }
     },
  ];

  const EditFormFields = [
    {label: 'Csv', attribute: 'layout', type: 'csv4', disabled: false, options: [], value: "" },
  ];

  const setSector = (data,type) => {
    if(type==='configureGalley'){
      setAirCraft(data);
      setState( (_prev) => {
        return { ..._prev, selected: {...data ,action: type},resetDataSource:false}
      });
    }
    else if(type==='editAircraft'){
      setState((_) => {
        return { ..._, resetDataSource: false, selected: { data,action: 'editAircraftType' },edit:true};
      })
    }
   else if(type==='deleteAircraft'){
    setState((_) => {
      return { ..._, resetDataSource: false,selected:data,delete:true ,deleteProg:false,edit:false};
    })
   }
   else{
    setState( (_prev) => {
      return { ..._prev, selected: {...data ,action: type},resetDataSource:false}
    });
   }
  };
  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };
  const fetchAirtcraftsType = async (page = 1, perPage = 50) => {

    filterData.page = page;
    filterData.limit = perPage;
    filterData.filters =  [];
    filterData.searchParam = searchKey;
    try {
      const res = await DFPAPIEndpointGalley.post('api/aircraftTypes/process', filterData);
      if(res && res.items){
        return res;
      }
    } catch (error) {
      console.error('Log: Error occured while fetching aircraft variants', error);
    }

  }
  const handleFormSubmit = async (e,updated) => {
    if(updated){
      setState((_prev) => {
        return { ..._prev,resetDataSource:!_prev.resetDataSource}
      });
      const body={
        model: updated.model,
        variant: updated.variant,
        capacity: parseInt(updated.capacity),
      }
      try {
          const resp = await DFPAPIEndpoint.post(`aircraftTypes`,body);
          if (resp.success) {
           const updatedMessage = resp.message.replace(/Aircraft type/gi, "Aircraft variant");
           setModalFormStatusObj({ text: updatedMessage });
}
      }
      catch (error) {
      const errorObj = JSON.parse(error.message)
        setModalFormStatusObj({ error: errorObj?.message||'Something went wrong. Please try again after some time.'});
      }
    }
    setState((_prev) => {
      return { ..._prev,resetDataSource:!_prev.resetDataSource}
    });
  }
      const handleViewIntlPriceClick = (indx) => {
      setState((_prev) => ({..._prev,selected: {..._prev.selected,action2: "IntlPriceList"},data:Array.isArray(data) && data[indx] ? data[indx] : {}}));
    };
    const onClose = () => {
      if (state.selected?.action2 === "IntlPriceList") {
        setState((prev) => ({
          ...prev,
          selected: {
            ...prev.selected,
            action2: false, 
          },
        }));
      } else {
        setState((prev) => ({
          ...prev,
          selected: false,
          edit: false,
        }));
    
        setModalFormStatusObj({ text: '' });
        setSeatPriceList({ date: new Date(), sector: 'dom' });
      }
    };
    
  const onAddItemHandler=()=>{
    setState( (_prev) => {
        return { ..._prev, selected: { action: 'createAircraftType' },resetDataSource:false ,edit:false};
      });
  }

const onUploadClose=(e)=>{
  if(state.selected.action==='configureGalley' && e){
    setState((_prev) => {
        return { ..._prev, selected: false,edit:false,resetDataSource: false  }
    });
  }
  else if(state.selected.action==='uploadLayout'&&uploadFileStatusBlock.length>0){
    setState((_prev) => {
      return { ..._prev, selected: false,edit:false,resetDataSource: true  }
  });
  }else{
    setState((_prev) => {
      return { ..._prev, selected: false,edit:false,resetDataSource: true  }
  });
  }
setUploadFileStatusBlock('')
}

const onCloseDelete=()=>{
  setState((_prev) => {
    return { ..._prev,resetDataSource:false,delete:false}
  });
setModalFormStatusObj({ text: "" });
}

const onContinue = async () => {
  setState((_prev) => ({
    ..._prev,
    deleteProg: true,
  }));

  try {
    const res = await DFPAPIEndpointGalley.delete(`galley/aircraftTypes/${state.selected.id}`);
    if (res.success) {
      const updatedMessage = res.message.replace(/Aircraft/gi, "Aircraft variant");
    setModalFormStatusObj({ text: updatedMessage });
      setTimeout(() => {
        setModalFormStatusObj({ text: '' });
        setState((_prev) => ({
          ..._prev,
          resetDataSource: !state.resetDataSource,
          delete: false,
          deleteProg: false,
        }));
      }, 1600);
    }
  } catch (error) {
    let {errorData}=JSON.parse(error.message);
      let errorMessage = "";
      errorMessage= errorData?.data?.message || 'Failed to Delete Aircraft';
    setModalFormStatusObj({ error:errorMessage });;

    setTimeout(() => {
      setModalFormStatusObj({ text: '' });
      setState((_prev) => ({
        ..._prev,
        delete: false,
        deleteProg: false,
      }));
    }, 1600);
  }
};

const delProps = {
  state,
  onContinue,
  onCloseDelete,
    }
    const onUploadFileChangeHandler = async (e) => {
      const file=e.target.files[0];
      setUploadedFile(e.target.files[0]);
      setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

      const formData = new FormData();
      formData.append('file', file);
      try {
         await DFPAPIEndpointGalley.post(`api/aircraftTypes/${state?.selected?.id}/layout/upload`, formData);
        setUploadedFile([]);
        setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
 
      } catch (error) {
        e.target.value = null;
        setUploadedFile([]);
        const errorObj = JSON.parse(error.message)
        let errHtml = "<div class='alert-danger'>";
        errHtml += `<div class='w-100 flexCol margBottom10'>${errorObj.data.Error}</div>`;

        if (errorObj.data?.errors && Array.isArray(errorObj.data.errors)) {
          errorObj.data.errors.forEach((er, i) => {
            errHtml += `
              <div key=${i} class="flexRow margBottom10">
                <div class='key'>Line Number: ${er.lineNumber}</div>
                <div class='flexCol'>
            `;
            er.errors.forEach((error, idx) => {
              errHtml += `<span key=${idx}>${error.message}</span>`;
            });
            errHtml += `</div></div>`;
          });
        }

        errHtml += `</div>`;

        setUploadFileStatusBlock(errHtml);
        setUploadedFile([]);
      }
  };

  const onPriceListUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');
    const body={
      st:priceSector,
      efd:formatDateByTimezone(new Date(dateChange),false),
       aid:state.selected?.id
    }
    
    const formData = new FormData();
    formData.append('scheduleLater', false);
    formData.append('listName', undefined);
    formData.append('targetSectorType', priceSector);
    formData.append('stores', undefined);
    formData.append('warehouses', undefined);
    formData.append('effectiveDate','');
    formData.append('aircraftTypeId',state.selected?.id);
    formData.append('file', file);
    try {
      await APIEndpoint.post(`seatPricelists/upload?st=${priceSector}&efd=${PriceDate}&aid=${state.selected?.id}`, formData,body);
      setUploadedFile([]);
      
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');

    }  catch(error) {
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400 && data?.errors) {
        data.errors.forEach( _ => {
        const lineNum = _.lineNumber;
        const errorMsgArr = [];
        _.errors.forEach(erObj => {
          errorMsgArr.push(`${erObj.field ? erObj.field : ""} | ${erObj.message} \n<br>`);

        });

        msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
    });
  } else if(status===0 && !data){
    msgContent += `Error occurred while uploading seat pricelist sheet!<br>Please try again.`;
}
else if(status === 400 && data && data?.Error){
  msgHeading = data?.Error;
  msgContent += `Error occurred while uploading seat pricelist sheet!<br>Please try again.`;
}
  else {
    msgContent += `Error occurred while uploading seat pricelist sheet!<br>Please fix the errors and re-upload.`;
  }


      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }

};

const onDownloadPricelistSampleFile = async() => {
  onDownloadXlsFile('samples/downloads/SeatPricelist_Upload_Sample','seat_pricelist')
 }
const onDownloadSampleFile=()=>{
    onDownloadXlsFile('samples/downloads/AircraftTypeLayout_Upload_Sample','AircraftTypeLayout_Upload_Sample')
}

  const onSearch = (e) => {
    setSearchKey(e.target.value);
  };

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
           <div className='flexRow width100 margBot10 margTop8 justifyContentSpaceBetween'>
           <div className='width100Menu justifyContentCenter flexRow'>
           <div className="margLeft margBot10 underline">
            <span><img  className="icon-size" alt='search' src={searchIcon} /></span>
            <span><input className="search" onChange={onSearch} type="search" placeholder="Search" value={searchKey}/></span>
            </div>
           </div>
           {createAircraftType? <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
            <button className="add-item-button" onClick={ onAddItemHandler }>
            {t('pages.pagesContent.aircrafts.createAircraft')}
            </button>
            </div>:<></>}
            </div>

          <DataGrid
            ref={tableRef}
            className='full-flex'
            columnResize
            columns={Columns}
            initialPageLimit={50}
            showDefaultFilters={false}
            searchKey={searchKey}
            rowSelection="multiple"
            resetDataSource={state?.resetDataSource}
            setSearchKey={(e) => onSearch(e)}
            getRows={fetchAirtcraftsType}
          />
        </>
      }
      {state && Boolean(state.selected)&& state.selected?.action === "createAircraftType" &&(
           <CreateAircraft
            key={state.selected?.action}
            title={"Create Aircraft Model"}
            airlines={'pal'}
            buttonLabel={preCompile.save}
            onSubmit={handleFormSubmit}
            aircraftStates={setState}
            setModalFormStatusObj={setModalFormStatusObj}
            onClose={onClose}
          />
        )
     }
     {state && Boolean(state.selected)&& state.selected?.action === "editAircraftType"&&(
           <CreateAircraft
            key={state.selected?.action}
            title={`Edit Aircraft Model - ${state.selected?.data.key} `}
            airlines={'pal'}
            buttonLabel={preCompile.save}
            editData={state.selected?.data}
            aircraftStates={setState}
            onSubmit={handleFormSubmit}
            setModalFormStatusObj={setModalFormStatusObj}
            onClose={onClose}
          />
        )
     }

      {state && Boolean(state.selected) &&state.selected?.action === "viewLayout"&& viewDetailsAircraftType && (
          <EditModal
            key={state.selected?.action}
            title={ `Seat Layout - ${state.selected?.key}`}
            onClose={onClose}
            showFieldsInColumn={true}
            fields={ EditFormFields.map( (elt) => {
                  return {...elt, initialValue: state.selected[elt.attribute]}
                })
            }
          />
        )
     }
     {
        state && Boolean(state.selected)&&state.selected.action==='uploadLayout'&&
        (<UploadModal
            modelTitle={`${preCompile.uploadLayout}-${state.selected.key}`}
            onUploadClose={onUploadClose}
            onDownloadSampleFile={onDownloadSampleFile}
            uploadedFile = { uploadedFile }
            onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
            uploadFileStatusBlock = { uploadFileStatusBlock }
        />)
      }
       {state&&state?.delete && <DeleteConf   {...delProps} buttonStat={state.deleteProg} modalFormStatusObj={modalFormStatusObj} description={`Are you sure you want to delete ${state?.selected?.model} ?`} />}

      {
        state && Boolean(state.selected)&&state.selected.action==='configureGalley'&&
        (<ConfigureGalley
            modelTitle={`Configure Galleys -${state.selected.key}`}
            onUploadClose={(e)=>onUploadClose(e)}
            airCraft={airCraft}
            state={state}
            onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
            onUpdateGalley={fetchAirtcraftsType}
            uploadFileStatusBlock = { uploadFileStatusBlock }
        />)
      }
        {state && Boolean(state.selected) &&state.selected?.action === "SeatPriceList"&& (
              <>
                <EditModal
                  key={state.selected?.action}
                  title={ `Seat Pricelist -  ${state.selected?.data?.model}`}
                  onClose={onClose}
                  showFieldsInColumn={true}
                  showDone={false}
                >
                <div className='dialog__body_container flexRow justifyContentSpaceBetween flexWrap'>
               <div className={`flexRow width100 justifyContentFlexStart alignItemsCenter margBot10`}>
               <div className='flexCol justifyContentSpaceEvenly' style={{marginRight:'1rem'}}>
                <label className={`fontRegular req`} >Effective Date</label>
                <div className={`dialog__description`}>
                 <NGODatePicker
                   style={{width: '17rem'}}
                   isclearable={false}
                   value={seatPriceList.date}
                   minDate={new Date()}
                   placeholder={t('effectiveDate')}
                   placeholdertext={t('datePickerPlaceholder')}
                  onChange={(e)=>setSeatPriceList({ ...seatPriceList, date: new Date(e.target.value) })}
                   />
      
             </div>
             </div>
               <div className='flexCol justifyContentSpaceEvenly '>
                <label className={`fontRegular req`}>Sectors</label>
                <div className={`dialog__description`}>
                  <select className='select-input-galley1'
                   onChange={(e) => setSeatPriceList({ ...seatPriceList, sector:(e.target.value) })}
                   value={seatPriceList.sector}
                  >
                    <option value="">Select Sector</option>
                   <option value="dom">Domestic</option>
                   <option value="int">International</option>
                  </select>
      
                </div>
                </div>
      
              </div>
      
            <div className="flexRow alignItemsCenter"  id="caterer-table" style={{whiteSpace:'nowrap', width:'100%'}}>
      
      
            <table>
              <thead>
                <tr style={{width:'100%'}} className='sticky'>
                <th style={{width:"20%"}}>From</th>
                  <th style={{width:"20%"}}>To</th>
                  <th>CGST</th>
                  <th>SGST</th>
                  <th>UTGST</th>
                  <th>IGST</th>
                  <th>Price</th>
                  <th>Price(SSR)</th>
                  <th>Intl. Pricing</th>
                </tr>
              </thead>
              <tbody>
              
              {Array.isArray(data) && data.length > 0 ? (
              data.map((item, idx) => (
              <tr key={item?._id ?? idx} style={{ backgroundColor: `${!Number(idx%2)?themedColor.background :themedColor.hover}`, color: '#fff' }}>
              <td>{item?.fromCategory ?? "—"}</td>
              <td>{item?.toCategory ?? "—"}</td>
              <td>{item?.cgst ?? "—"}</td>
              <td>{item?.sgst ?? "—"}</td>
              <td>{item?.utgst ?? "—"}</td>
              <td>{item?.igst ?? "—"}</td>
              <td>{item?.itemPrice ?? "—"}</td>
              <td>{item?.priceSSR ?? "NA"}</td>
              <td>
              <button
              className="grid-download-btnStyle1"
              style={{ marginLeft: "1rem" }}
              onClick={()=>handleViewIntlPriceClick(idx)}
              >
              View
              </button>
              </td>
              </tr>
              ))
              ) : (
              <tr>
              <td colSpan={9} style={{ textAlign: "center" }}>
              No Items Found
              </td>
              </tr>
              )}
              </tbody>

            </table>
      
          </div>
          </div>
      
                </EditModal>
                </>
              )
           }
           {state && Boolean(state.selected) && state.selected?.action2 === "IntlPriceList"&& (
            <EditModal
                  key={state.selected?.action2}
                  title={ `Intl Pricing -  ${state.selected?.data?.model}`}
                  onClose={onClose}
                  showDone={false}
                  showFieldsInColumn={true}>
                <div className="flexRow alignItemsCenter"  id="caterer-table" style={{whiteSpace:'nowrap', width:'100%'}}>
                <table>
                <thead>
                <tr style={{ width: '100%' }} className="sticky">
                <th>Currency</th>
                <th>Amount</th>
                <th>Amount (SSR)</th>
                </tr>
                </thead>
                <tbody>
                {state?.data && state.data?.intlPrices && state.data?.intlPrices?.length>0 ? (
                state.data.intlPrices?.map((item, index) => (
                <tr key={index}  style={{ backgroundColor: `${!Number(index%2)?themedColor.hover : themedColor.background}`, color: '#fff' }}>
                <td>{item?.currencyName && item?.currencyCode ? `${item.currencyName} (${item.currencyCode})` : "NA"}</td>
                <td>{item?.amount ?? "NA"}</td>
                <td>{item?.amountssr ?? item?.amountSsr ?? "NA"}</td>
                </tr>
                ))
                ) : (
                <tr>
                <td colSpan={3} style={{ textAlign: "center" }}>
                No Items Found
                </td>
                </tr>
                )}
                </tbody>
                </table>

                </div>
              </EditModal>
           )}
      {
              state && Boolean(state.selected)&&state.selected.action==='PricelistUploadLayout'&&
              (<UploadModal
                  modelTitle={`Upload Seat Pricelist - ${state.selected?.model}`}
                  onUploadClose={onUploadClose}
                  onDownloadSampleFile={onDownloadPricelistSampleFile}
                  uploadedFile = { uploadedFile }
                  onUploadFileChangeHandler = { (e) => onPriceListUploadFileChangeHandler(e) }
                  uploadFileStatusBlock = { uploadFileStatusBlock }
                  priceSector={priceSector }
                  setPriceSector={setPriceSector}
                  dateChange={dateChange}
                  setDateChange={setDateChange}
              />)
            }
       {
          !ready &&<div className='overlay_hide sub'></div>
        }
    </div>
  )
}